<template>
    <b-modal :visible="visible" title="Patient Already Has an Open Order" size="xl" hide-footer no-fade
        @hidden="$emit('update:visible', false)">
        <p>
            This patient already has {{ openOrders.length }}
            open order{{ openOrders.length === 1 ? "" : "s" }}. Merge the new items into an existing order,
            or create a separate new order anyway.
        </p>
        <OrdersListComponent :orders="openOrders" expandable :mergable="canMerge" :hide-actions-column="!canMerge"
            :mergable-statuses="mergeableStatuses" multiline-rx-rfs responsive @merge-order="onMerge" />
        <div class="text-right mt-3">
            <b-button variant="secondary" class="mr-2" @click="close">Cancel</b-button>
            <b-button variant="warning" @click="createAnyway">Create new order anyway</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Order, OrderStatus, MERGEABLE_TARGET_STATUSES } from "@/models/Order";
import OrdersListComponent from "@/components/Order/OrdersListComponent.vue";

@Component({ components: { OrdersListComponent } })
export default class DuplicateOrderModal extends Vue {
    @Prop({ type: Boolean, default: false }) visible!: boolean;
    @Prop({ type: Array, default: () => [] }) openOrders!: Order[];
    @Prop({ type: Boolean, default: true }) canMerge!: boolean;

    // Guards against a double-click firing merge/create-anyway twice before the modal closes.
    private handled = false;

    @Watch("visible")
    onVisibleChange(visible: boolean) {
        if (visible) this.handled = false;
    }

    get mergeableStatuses(): OrderStatus[] {
        return MERGEABLE_TARGET_STATUSES;
    }

    onMerge(order: Order) {
        if (this.handled) return;
        this.handled = true;
        this.$emit("merge", order);
        this.close();
    }

    createAnyway() {
        if (this.handled) return;
        this.handled = true;
        this.$emit("create-anyway");
        this.close();
    }

    close() {
        this.$emit("update:visible", false);
    }
}
</script>
